/**
 * RTWO Asset & Token Engine — Null VM Runtime Adapter
 */

import type { AssetId, RTWOAssetLifecycleStage } from '../domain-models';
import type { IVmRuntimeAdapter, VmRuntimeAdapterStatus } from './vm-runtime-adapter-interface';

export class NullVmRuntimeAdapter implements IVmRuntimeAdapter {
  readonly adapterId = 'null-vm-runtime-adapter';
  readonly adapterName = 'Null VM Runtime Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): VmRuntimeAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async transitionLifecycle(_assetId: AssetId, _targetStage: RTWOAssetLifecycleStage) {
    return null;
  }
}
